import {module as Module} from "modujs";
import { CUSTOM_EVENT } from '../config'
import {CAROUSEL_DEFAULT_OPTS, CAROUSEL_INSIGHTS_OPTS, CAROUSEL_MIN_OPTS} from "../constants/carousel";
import Splide from "@splidejs/splide";
import {$screen} from "../stores/screen.js";

export default class Carousel extends Module {

    constructor(m) {
        super(m);

        // Binding
        this.onResizeBind = this.onResize.bind(this);
        this.onArrowUpdatedBind = this.onArrowUpdated.bind(this);

        // UI
        this.$carousel = this.$("carousel")[0];

        // Data
        this.splide = null;
        this.type = this.getData('type')
        this.$controls = this.$('controls')[0]
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        this.initCarousel()
        this.bindEvents()
        this.onResize()
    }

    destroy() {
        super.destroy();
        this.destroyCarousel()
        this.unbindEvents()
    }

    ///////////////
    // Methods
    ///////////////

    bindEvents() {
        this.unbindScreenListener = $screen.subscribe(this.onResizeBind);
        window.addEventListener(CUSTOM_EVENT.RESIZE_END, this.onResizeEnd);
    }

    unbindEvents() {
        this.unbindScreenListener?.()
        window.removeEventListener(CUSTOM_EVENT.RESIZE_END, this.onResizeEnd);
    }

    onResize() {
        const controlsWidth = this.$controls.offsetWidth
        this.el.style.setProperty("--controls-width", `${controlsWidth}px`);
    }

    onResizeEnd = () => {
        if (this.splide.length > 2) {
            return;
        }

        if (window.innerWidth > 500) {
            this.$('pagination').forEach((el) => el.classList.add('u-none'));
        } else {
            this.$('pagination').forEach((el) => el.classList.remove('u-none'));
        }
    }

    onArrowUpdated(prev, next) {
        if (prev.disabled) {
            prev.disabled = false
            prev.classList.add('-disabled')
        } else {
            prev.classList.remove('-disabled')
        }

        if (next.disabled) {
            next.disabled = false
            next.classList.add('-disabled')
        } else {
            next.classList.remove('-disabled')
        }
    }

    initCarousel() {
        if (!this.$carousel) return
        let options;
        switch (this.type) {
            case 'insights':
                options = CAROUSEL_INSIGHTS_OPTS();
                break;

            case 'min':
                options = CAROUSEL_MIN_OPTS();
                break;

            case 'projects':
                options = CAROUSEL_INSIGHTS_OPTS();
                break;

            default:
                options = CAROUSEL_DEFAULT_OPTS({
                    autoWidth: true
                });
                break;
        }
        this.splide = new Splide(this.$carousel, options);
        this.splide.on('arrows:updated', this.onArrowUpdatedBind);
        this.splide.mount()
    }

    destroyCarousel() {
        this.splide?.off( 'arrows:updated', this.onArrowUpdatedBind);
        this.splide?.destroy(true);
    }
}
